const sectionLabel: React.CSSProperties = {
  fontSize: '0.5625rem',
  fontWeight: 700,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginTop: '0.5rem',
};

export default function TradeStructureCardMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#22c55e' }} /> Trade Structure</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#e5e7eb', marginBottom: '0.375rem' }}>
          Concentrated Winner Profile
        </div>

        {/* Win/loss bar */}
        <div style={{ display: 'flex', gap: 4, marginBottom: '0.125rem' }}>
          <div style={{ flex: 27, height: 10, borderRadius: 4, background: '#22c55e' }} />
          <div style={{ flex: 35, height: 10, borderRadius: 4, background: '#ef4444' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.5625rem', color: '#6b7280' }}>
          <span>Wins (27)</span>
          <span>Losses (35)</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.5625rem', color: '#9ca3af', marginTop: 2 }}>
          <span>44% win rate</span>
          <span>62 trades</span>
        </div>

        <div style={sectionLabel}>Characteristics</div>
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', lineHeight: 1.6 }}>
          Top 20% trades: 81% of gains<br />
          Payoff ratio: 2.0x<br />
          Median duration: 3d
        </div>

        <div style={{
          marginTop: 'auto',
          paddingTop: '0.75rem',
          fontSize: '0.6875rem',
          color: '#6b7280',
          fontStyle: 'italic',
        }}>
          Profit driven by a subset of large winning trades.
        </div>
      </div>
      <div className="platform-mock-caption">
        Trade Structure shows where the profit actually comes from — concentrated in a few winners or spread across many.
      </div>
    </div>
  );
}
